import { createSelector } from 'reselect'

import { selectComposedReportState } from './selectComposedReportState'

export const selectPartnersInScope = createSelector(
  [selectComposedReportState],
  ({ partnersInScope }) => partnersInScope
)
